module.exports = __webpack_public_path__ + "img/b2.f51c9b32.png";